// removed by extract-text-webpack-plugin
module.exports = {"sorting":"_3J4lAfPYm-B908FOY9C6Mx","item":"_3ypd4R8REh4-1CkgXWNCsi"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/Search/Ticket/style.css
// module id = 2432
// module chunks = 0